import IResult from 'src/dataModel/IResult';
import IReq from './IReq';
import IResp from './IResp';
import Urls from 'src/config/Urls';
import http from 'src/utils/ajaxUtils';

/**
 * 接口描述
 * @param param 参数，IReq类型
 */
async function addOrEditQualificationEducation(param: IReq): Promise<IResult<IResp>> {
  const resp = await http.post(Urls.addOrEditQualificationEducation, param);
  return resp;
}

export default addOrEditQualificationEducation;


// WEBPACK FOOTER //
// ./src/api/progress/addOrEditQualificationEducation/index.ts